// viewonly-chrome — the read-only view-only surface (clientside-teacher-review,
// task 5). editor-core is constructed by main.js with readOnly:true (buffer not
// editable) and the Run/Stop controls stay live, so there is no host chrome to wire
// here. Kept as its own module so the data-surface dispatch is uniform across surfaces.
//
// one-tab-same-tab-launches (Trello bD1oe35m): the four "Run it" pages (read-the-code, plan
// explain-code, worked-example, variable boxes) render this template and are now launched in
// the classroom's own tab with the activity top bar, whose Back is the way out — so the
// standing close-the-tab control and the dead `#surface-back` wiring are
// gone. None of the run pages has a finish line, so none gets a countdown.
//
//   wire(ctx) — ctx = { core, payload, trinketId, clientsideMode, isOwner, editorApi, doc }

export function wire() {
  // Nothing to wire: the activity top bar (surface-topbar-chrome.js) is wired eagerly by main.js.
}
